// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".add-co-modal .modal-content{height:100vh;display:flex;flex-direction:column;justify-content:center}.add-co-modal .modal-card-body{overflow:visible}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
